// AWS Cognito configuration for Thinking Council
const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
        username: false
      }
    }
  }
};

// Validate required environment variables
if (!process.env.REACT_APP_COGNITO_USER_POOL_ID || !process.env.REACT_APP_COGNITO_CLIENT_ID) {
  console.error('Missing required AWS Cognito environment variables. Check your .env file.');
}

export default awsConfig;
